import { render } from "./dialogClonarFicha.vue?vue&type=template&id=6d569592&scoped=true"
import script from "./dialogClonarFicha.vue?vue&type=script&lang=js"
export * from "./dialogClonarFicha.vue?vue&type=script&lang=js"

import "./dialogClonarFicha.vue?vue&type=style&index=0&id=6d569592&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d569592"]])

export default __exports__